import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { renderRedirect } from "../../util";
import { setDigioOption } from "../../util/digio";
import { createKYCRequest, fetchDigilockerData } from "./api";
import { checkPanStatus, fetchKraDetails } from "./kraApi";
import { fetchSignApplication, updateSignApplication } from "../BasicProfile/api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Footer from "../../Components/footer";
import { spinnerService } from "../../Components/spinner.service";
const configApp = require("../../config");

class VerifyKYC extends Component {
  state = {
    loading: false,
    showSandboxModal: false,
    sandboxAadhaar: "",
    sandboxOtp: "",
    sandboxStep: 1,
    sandboxError: "",
    panInput: "",
    dobInput: null,
    errors: {
      panInput: "",
      dobInput: ""
    }
  };

  async componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("status") || urlParams.has("error_code") || urlParams.has("digio_code")) {
      const statusVal = urlParams.get("status");
      if (statusVal === "success" || urlParams.has("digio_code")) {
        this.setState({ loading: true });
        try {
          await this.fetchDigilockerData();
          return;
        } catch (err) {
          console.error("Auto fetch digilocker error:", err);
        }
      }
      let options = setDigioOption(
        configApp.REACT_APP_DIGIO_ENV || "sandbox",
        "https://uat.trdr.money/images/trdr-horizontal.png",
        "#000000",
        "#FFFFFF",
        this.fetchDigilockerData,
        true
      );
      let digio = new window.Digio(options);
      digio.init();
    }

    this.setState({ loading: true });
    try {
      let profileData = await fetchSignApplication();
      if (profileData && profileData.data && profileData.data.fetch_signup_application) {
        let data = profileData.data.fetch_signup_application;
        let date = data.dob ? decodeURIComponent(data.dob) : "";
        this.setState({
          panInput: data.pan || "",
          dobInput: date ? (date.split("/").length === 3 ? new Date(date.split("/").reverse().join("-")) : new Date(date)) : null
        });
      }
    } catch (err) {
      console.error("Error prefilling PAN/DOB:", err);
    } finally {
      this.setState({ loading: false });
    }
  }

  renderRedirect = () => {
    renderRedirect(this.props, "/pan");
  };

  fetchDigilockerData = async (sandboxAadhaar = null) => {
    this.setState({ loading: true });
    spinnerService.show("mainSpinner", "Fetching KYC Details...");
    try {
      await fetchDigilockerData(sandboxAadhaar);
      this.renderRedirect();
    } catch (err) {
      console.error("fetchDigilockerData error:", err);
    } finally {
      this.setState({ loading: false });
      spinnerService.hide("mainSpinner");
    }
  };

  handlePanChange = (e) => {
    let value = e.target.value.toUpperCase();
    let errors = { ...this.state.errors };
    errors.panInput = "";
    this.setState({ panInput: value, errors });
  };

  handleDobChange = (date) => {
    let errors = { ...this.state.errors };
    errors.dobInput = "";
    this.setState({ dobInput: date, errors });
  };

  handleProceed = async (e) => {
    e.preventDefault();
    let errors = { panInput: "", dobInput: "" };
    let isValid = true;

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!this.state.panInput || !panRegex.test(this.state.panInput.trim())) {
      errors.panInput = "Invalid PAN number format (e.g. ABCDE1234F)";
      isValid = false;
    }

    if (!this.state.dobInput) {
      errors.dobInput = "Date of Birth is required";
      isValid = false;
    }

    if (!isValid) {
      this.setState({ errors });
      return;
    }

    this.setState({ loading: true, errors });

    try {
      const pad = (num) => String(num).padStart(2, '0');
      let dobStr = "";
      if (this.state.dobInput instanceof Date) {
        const d = this.state.dobInput;
        dobStr = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
      } else if (typeof this.state.dobInput === "string") {
        dobStr = this.state.dobInput;
      }

      // Save PAN and DOB first
      await updateSignApplication({
        pan: this.state.panInput.trim().toUpperCase(),
        dob: dobStr
      });

      // Check KRA status
      const statusRes = await checkPanStatus(this.state.panInput.trim().toUpperCase(), dobStr);
      if (statusRes && statusRes.isKRAVerified) {
        // Fetch details to auto-fill database
        const detailsRes = await fetchKraDetails(this.state.panInput.trim().toUpperCase(), dobStr);
        if (detailsRes && detailsRes.status) {
          this.setState({ loading: false });
          renderRedirect(this.props, "/personal");
        } else {
          this.setState({
            loading: false,
            errors: {
              ...this.state.errors,
              panInput: detailsRes?.message || "Failed to fetch details from KRA database."
            }
          });
        }
      } else {
        // If not found, start Aadhaar eKYC via Digio
        await this.callDigio();
      }
    } catch (err) {
      console.error("KYC proceed error:", err);
      this.setState({ loading: false });
    }
  };

  handleSandboxAadhaarSubmit = (e) => {
    e.preventDefault();
    if (this.state.sandboxAadhaar.length !== 12 || isNaN(this.state.sandboxAadhaar)) {
      this.setState({ sandboxError: "Aadhaar card must be a 12-digit number" });
      return;
    }
    this.setState({ sandboxStep: 2, sandboxError: "" });
  };

  handleSandboxOtpSubmit = async (e) => {
    e.preventDefault();
    if (this.state.sandboxOtp !== "123456") {
      this.setState({ sandboxError: "Invalid OTP. Use '123456' for sandbox verification." });
      return;
    }
    this.setState({ showSandboxModal: false, loading: true, sandboxError: "" });
    try {
      await this.fetchDigilockerData(this.state.sandboxAadhaar);
    } catch (err) {
      console.log("Sandbox fetch error:", err);
    } finally {
      this.setState({ loading: false });
    }
  };

  callDigio = async () => {
    this.setState({ loading: true }); // Start loading

    try {
      let kycRequest = await createKYCRequest();
      if (kycRequest?.data?.create_kyc_request) {
        let kycData = kycRequest.data.create_kyc_request;
        if (configApp.REACT_APP_DIGIO_SANDBOX === "true") {
          console.log("[SANDBOX] Opening mock Digio Aadhaar Verification Sandbox.");
          this.setState({ showSandboxModal: true, sandboxStep: 1, sandboxAadhaar: "", sandboxOtp: "", sandboxError: "" });
          return;
        }
        let options = setDigioOption(
          configApp.REACT_APP_DIGIO_ENV || "sandbox",
          "https://uat.trdr.money/images/trdr-horizontal.png",
          "#000000",
          "#FFFFFF",
          this.fetchDigilockerData,
          true
        );
        console.log({ kycData });
        console.log({ options });
        let digio = new window.Digio(options);
        digio.init();
        digio.submit(
          kycData.id,
          kycData.customer_identifier,
          kycData.access_token.id
        );
      }
    } catch (e) {
      console.log("digio submit error:", e);
    } finally {
      this.setState({ loading: false }); // Stop loading after API response
    }
  };

  render() {
    return (
      <div className="col-md-6 col-lg-5 col-xl-4">
        <div className="container my-auto py-4 bg-white shadow-lg rounded">
          <div className="row mt-2">
            <div className="col-11 col-lg-11 mx-auto">
              <h1>KYC Details</h1>

              <p>
                <b>SEBI guidelines require us to collect your geo-location.</b>
              </p>
              <p className="alert alert-warning alert-dismissible fade show text-left text-1">
                <p>Allow your web browser to access location.</p>
                <p>
                  If prompted to allow location access, please allow access to
                  complete the application process.
                </p>
              </p>

              <form id="registerForm" className="form-border" onSubmit={this.handleProceed}>
                {this.state.errors.panInput && (
                  <div className="alert alert-danger p-2 text-1">{this.state.errors.panInput}</div>
                )}
                {this.state.errors.dobInput && (
                  <div className="alert alert-danger p-2 text-1">{this.state.errors.dobInput}</div>
                )}

                <div className="form-group icon-group floating-label-wrap">
                  <input
                    type="text"
                    className="form-control floating-label-field floating-label-field--s1"
                    id="panInput"
                    required
                    value={this.state.panInput}
                    placeholder="PAN Number"
                    onChange={this.handlePanChange}
                    noValidate
                  />
                  <label className="floating-label">PAN Number</label>
                  <span className="icon-inside text-primary">
                    <i className="fas fa-file"></i>
                  </span>
                </div>

                <div className="form-group icon-group floating-label-wrap date-of-birth">
                  <DatePicker
                    className="form-control floating-label-field floating-label-field--s1"
                    selected={this.state.dobInput}
                    onChange={this.handleDobChange}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Date of birth"
                    maxDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    required
                  />
                  <label className="floating-label">Date of birth</label>
                  <span className="icon-inside text-primary">
                    <i className="fas fa-calendar"></i>
                  </span>
                </div>

                <button
                  className="btn btn-primary btn-block text-uppercase mt-4"
                  type="submit"
                  disabled={this.state.loading}
                >
                  {this.state.loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      Processing...
                    </>
                  ) : (
                    "PROCEED"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>

        {this.state.showSandboxModal && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}>
            <div className="bg-white p-4 rounded shadow-lg" style={{ width: "350px", position: "relative" }}>
              <button
                type="button"
                onClick={() => this.setState({ showSandboxModal: false })}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "15px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer"
                }}
              >
                &times;
              </button>
              <div className="text-center mb-3">
                <h4 style={{ color: "#007bff", fontWeight: "bold" }}>digio Sandbox</h4>
                <p className="text-muted text-1">Aadhaar Offline KYC Simulation</p>
              </div>

              {this.state.sandboxStep === 1 ? (
                <form onSubmit={this.handleSandboxAadhaarSubmit}>
                  <div className="form-group">
                    <label>Aadhaar Card Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter 12-digit Aadhaar"
                      maxLength="12"
                      value={this.state.sandboxAadhaar}
                      onChange={(e) => this.setState({ sandboxAadhaar: e.target.value, sandboxError: "" })}
                      required
                    />
                  </div>
                  {this.state.sandboxError && (
                    <div className="alert alert-danger p-2 text-1">{this.state.sandboxError}</div>
                  )}
                  <button type="submit" className="btn btn-primary btn-block mt-3">
                    Send OTP
                  </button>
                </form>
              ) : (
                <form onSubmit={this.handleSandboxOtpSubmit}>
                  <div className="form-group">
                    <label>Enter 6-digit OTP</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter 123456"
                      maxLength="6"
                      value={this.state.sandboxOtp}
                      onChange={(e) => this.setState({ sandboxOtp: e.target.value, sandboxError: "" })}
                      required
                    />
                    <small className="form-text text-muted">Use mock OTP: <strong>123456</strong></small>
                  </div>
                  {this.state.sandboxError && (
                    <div className="alert alert-danger p-2 text-1">{this.state.sandboxError}</div>
                  )}
                  <button type="submit" className="btn btn-success btn-block mt-3">
                    Verify & Continue
                  </button>
                </form>
              )}
            </div>
          </div>
        )}

        <Footer />
      </div>
    );
  }
}

export default withRouter(VerifyKYC);
